var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 0C9.018 0 0 9.019 0 20c0 11.072 9.017 20 20 20s20-8.928 20-20C39.998 9.019 30.981 0 19.998 0zm0 36.875C10.67 36.875 3.123 29.286 3.123 20s7.59-16.875 16.875-16.875c9.286 0 16.875 7.589 16.875 16.875s-7.589 16.875-16.875 16.875z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.09 21.672l2.672 8.142 5.937-19.677-17.176 11.28z"
  })));
}
export default SvgTracker;